/**
 * Portão de rota por papel.
 *
 * É conveniência de navegação, não segurança: a autorização real acontece no
 * backend, em toda requisição. Aqui só evitamos mostrar uma tela que vai
 * responder 403.
 */

import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";

interface RequireRoleProps {
  papeis: string[];
  children: ReactNode;
}

export default function RequireRole({ papeis, children }: RequireRoleProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="shell">
        <p className="muted">Verificando sessão…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/entrar" replace state={{ from: location.pathname }} />;
  }

  // Senha temporária bloqueia o resto do sistema, exatamente como no backend.
  if (user.must_change_password) {
    return <Navigate to="/trocar-senha" replace />;
  }

  if (!papeis.includes(user.role)) {
    return (
      <div className="shell">
        <div className="card">
          <h1>Sem acesso</h1>
          <p className="sub">
            Sua conta ({user.role}) não tem permissão para esta área da plataforma.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
